export default "__VITE_ASSET__CRsqheJ0__"